

export const appConfig={

    headRoute:'',
    appName:'SkyRise Travels'

}